import { render } from "./ShoppingCartBtn.vue?vue&type=template&id=e8843330&scoped=true"
import script from "./ShoppingCartBtn.vue?vue&type=script&lang=js"
export * from "./ShoppingCartBtn.vue?vue&type=script&lang=js"

import "./ShoppingCartBtn.vue?vue&type=style&index=0&id=e8843330&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8843330"]])

export default __exports__